import { Text } from '@optiaxiom/react';

const formatExecutionTime = (executionTime: number) => {
  return `${executionTime.toFixed(2)}s`;
};

export const ExecutionTimeCell = ({ time }: { time: number }) => {
  return <Text fontSize="md">{formatExecutionTime(time)}</Text>;
};
